import React from 'react';
import classnames from 'classnames';
import { balanceWithCurrency, accountFormatter } from '../format';
export function AccountDetails(_a) {
    var account = _a.account, _b = _a.showBalance, showBalance = _b === void 0 ? true : _b, ariaInvalid = _a.ariaInvalid, locale = _a.locale;
    var _c = account !== null && account !== void 0 ? account : {}, balance = _c.balance, accountNumber = _c.accountNumber, currencyCode = _c.currencyCode;
    var isInvalidWithNoAccount = !account && (ariaInvalid === 'true' || ariaInvalid === true);
    return (React.createElement("div", { className: classnames('ffe-small-text', 'ffe-account-selector-single__details', {
            'ffe-account-selector-single__details--invalid-empty': isInvalidWithNoAccount,
        }) }, account && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ffe-account-selector-single__details--left" }, accountFormatter(accountNumber)),
        showBalance && (React.createElement("div", { className: "ffe-account-selector-single__details--right" }, balanceWithCurrency(balance, locale, currencyCode)))))));
}
